import { Injectable } from '@angular/core';
import {ApiPathsService} from "../../api-paths.service";
import { BehaviorSubject, Subject, Subscription } from "rxjs";
import {Permission} from "../../Login/_guards/Permission";
import { environment } from "../../../environments/environment";
import { debounceTime } from 'rxjs/operators';
import {GetCarrello} from "../../../environments/Modules/Marketplace/ProductUtility";

@Injectable({
  providedIn: 'root'
})
export class GlobalStoreService {
  constructor(
              private apiPaths: ApiPathsService,
              public permission: Permission
  ) {
    this.setupSearchDebouncer();
    this.setupTriggeredDebouncer();
    this.setupCartDataDebouncer();
   }
  private environment = environment;
  subscriptions: Subscription = new Subscription();
  private NOTIFICHE = new BehaviorSubject<any[]>([]);
  private DATA = new BehaviorSubject<any>(undefined);
  private FULLSCREEN = new BehaviorSubject<boolean>(undefined);
  private CART_DATA = new BehaviorSubject<{data:any[], richieste:number, open: boolean, openCarrello:boolean, dataCarrello: any[]}>(undefined);
  private dataStore: { Notifiche: any[], Data: any, FullScreen: boolean, CartData: {data:any[], richieste, open: boolean, openCarrello:boolean, dataCarrello: any[]} } = { Notifiche: [], Data: undefined, FullScreen: false, CartData:{data: [], richieste:0, open:false, openCarrello:false, dataCarrello: []} };
  readonly $notifiche = this.NOTIFICHE.asObservable();
  readonly $cartData = this.CART_DATA.asObservable();
  readonly $data = this.DATA.asObservable();
  readonly $fullscreen = this.FULLSCREEN.asObservable();
  refreshNotifiche = () => this.NOTIFICHE.next(Object.assign({}, this.dataStore).Notifiche);
  refreshData = () => this.DATA.next(Object.assign({}, this.dataStore).Data);
  refreshFullScreen = () => this.FULLSCREEN.next(Object.assign({},this.dataStore).FullScreen);
  refreshCartData = () => this.CART_DATA.next(Object.assign({}, this.dataStore).CartData);
  private searchDecouncer$: Subject<string> = new Subject();
  private triggeredDebouncer$: Subject<string> = new Subject();
  private cartDebouncer$: Subject<{data:any[], richieste, open}> = new Subject();
  updateNotifiche() {

  }
  private setupCartDataDebouncer(){
    this.cartDebouncer$.pipe(
      debounceTime(500),
    ).subscribe((data: any) => {
      this.apiPaths.ClassicGet(`/progetti/carrello/get`).subscribe(data => {
        this.dataStore.CartData = {data: data.data, richieste: data.data?.length, open: this.dataStore.CartData.open, openCarrello: this.dataStore.CartData.openCarrello, dataCarrello: GetCarrello()};
        this.refreshCartData();
      })
    })
  }

  public toggleCart() {
    this.dataStore.CartData = {...this.dataStore.CartData, open: !this.dataStore.CartData.open};
    this.refreshCartData();
  }
public togglecarrelloCart() {
  this.dataStore.CartData = {...this.dataStore.CartData, openCarrello: !this.dataStore.CartData.openCarrello};
  this.refreshCartData();
}


  private setupSearchDebouncer(): void {
    this.searchDecouncer$.pipe(
      debounceTime(500),
      //distinctUntilChanged(),
    ).subscribe((term: any) => {
       const Alerts = this.environment['Alerts'];
      if (!Alerts?.length) return;
      this.setNotifiche([]);
      Alerts.forEach(x=> this.GetAlerts(x));
    });
  }
  private setupTriggeredDebouncer(): void {
    this.triggeredDebouncer$.pipe(
      debounceTime(500),
      //distinctUntilChanged(),
    ).subscribe((trigger: any) => {
      this.setNotifiche(this.dataStore.Notifiche.filter(x => x.trigger != trigger));
      const Alerts = this.environment['Alerts'];
      if (!Alerts?.length) return;
      Alerts.filter(x => x.trigger == trigger)?.forEach(x => this.GetAlerts(x));
    });
  }

  getCartData() {
    this.cartDebouncer$.next();
  }

  GetAllNotifications() {
    this.searchDecouncer$.next();
  }

  GetTriggeredAlerts(trigger: string) {
    console.log("Alerts Refresh Triggered with: ", trigger);
    this.triggeredDebouncer$.next(trigger);
  }
  GetAlerts(item: any) {
    if (!item?.canRead(item, this?.permission)) return;
    this?.subscriptions.add(this?.apiPaths.ClassicGet(`${item.restRoute}`).subscribe(data => {
      this?.ConcatNotifiche(item.map(data)?.map(x => {
        if (typeof x == 'string')
          return Object.assign({}, item, {value: x})
        return Object.assign({}, item, x)
      }), item);
    }))
  }

  setNotifiche(data: any[]) {
    this.dataStore.Notifiche = data;
    this.refreshNotifiche();
    console.log("Notifiche: ", this.dataStore.Notifiche);
  }
  ConcatNotifiche(data: any[], item?: any) {
    this.dataStore.Notifiche = [...this.dataStore.Notifiche?.filter(x => !item || item.restRoute != x.restRoute), ...data];
    this.refreshNotifiche();
  }
  setData(data: any) {
    this.dataStore.Data = data;
    this.refreshData();
    console.log("Stored Data: ", this.dataStore.Data);
  }

  setFullScreen(data: boolean) {
    this.dataStore.FullScreen = data;
    this.refreshFullScreen();
  }
}
